export default "__VITE_ASSET__34e6e5be__"